import { IListTeacher } from "../../types/request_data/teachers";
export const teacherJSON = {
  listTeacher: ({
    pageNo,
    limit,
    sortKey,
    sortOrder,
    searchTerm,
    state,
    className,
    school,
    subjects,
  }: IListTeacher) => {
    let data: any = {
      pageNo: pageNo,
      limit: limit,
      sortKey: sortKey,
      sortOrder: sortOrder,
      needCount: true,
      searchTerm: searchTerm,
      state: state,
      class: className,
      school: school,
    };
    if (subjects) {
      subjects.forEach((item: any, index: number) => {
        data = { ...data, [`subjects[${index}]`]: item.value };
      });
    }
    return data;
  },
};
